import { useEffect } from 'react'
import { useSearch } from '@faststore/sdk'
import type { IStoreSelectedFacet } from '@faststore/api'
import QuickFilterButton from 'src/components/sections/ProductGalleryV2/filters/QuickFilterButton'
import { TruckShippingIcon } from 'src/components/Icons/TruckShippingIcon'
import { LightningIcon } from 'src/components/Icons/FilterIcons/LightningIcon'
import { StoreIcon } from 'src/components/Icons/Store'
import { useAddressContext } from 'src/components/checkout/steps/shipping/context/address-context'
import { hasQuickFilters } from 'src/utils/plp/QuickFilters'

import type { Facet } from '../types'

type QuickFiltersMobileProps = {
  facet: Facet
  onChange: (value: IStoreSelectedFacet) => void
}

export function DeliveryAndPickup({
  facet,
  onChange,
}: Readonly<QuickFiltersMobileProps>) {
  const { postalCode } = useAddressContext()
  const {
    state: { selectedFacets },
    setFacets,
  } = useSearch()

  const deliveryFacetValue = facet?.values.find(
    (value) => value.value?.toLocaleLowerCase() === 'delivery'
  )

  const pickupFacetValue = facet?.values.find(
    (value) => value.value?.toLocaleLowerCase() === 'pickup-all'
  )

  const stringFacets = selectedFacets
    .map(
      (filter: { key: string; value: string }) =>
        `${filter.key}=${filter.value}`
    )
    .join(',')

  const quickFiltersIsApplied = hasQuickFilters(stringFacets)

  useEffect(() => {
    if (!quickFiltersIsApplied) {
      const facetsWithoutDeliveryAndPickup = selectedFacets.filter(
        (filter) => filter.value !== 'delivery' && filter.value !== 'pickup-all'
      )

      setFacets(facetsWithoutDeliveryAndPickup)
    }
  }, [quickFiltersIsApplied, selectedFacets, setFacets])

  if (!postalCode || !quickFiltersIsApplied) {
    return null
  }

  return (
    <div
      className="flex flex-col gap-4 py-4 border-b border-gray"
      data-testid="delivery-and-pickup-filter"
    >
      <span className="flex items-center gap-2 text-base text-restructure-primary font-medium font-inter text-left leading-[21px]">
        <TruckShippingIcon filledIcon />
        Tipo de entrega
      </span>
      <div className="w-full flex flex-row items-center justify-center ">
        <div className="flex gap-2 flex-1 flex-wrap">
          <QuickFilterButton
            facetKey={deliveryFacetValue?.key ?? ''}
            facetValue={deliveryFacetValue}
            onClick={onChange}
            label="Receba em casa"
            Icon={LightningIcon}
          />

          <QuickFilterButton
            facetKey={pickupFacetValue?.key ?? ''}
            facetValue={pickupFacetValue}
            onClick={onChange}
            label="Retirar na loja"
            Icon={StoreIcon}
          />
        </div>
      </div>
    </div>
  )
}
